import { render } from "./TestAndroid.vue?vue&type=template&id=75b21912&scoped=true&ts=true"
import script from "./TestAndroid.vue?vue&type=script&lang=ts"
export * from "./TestAndroid.vue?vue&type=script&lang=ts"

import "./TestAndroid.vue?vue&type=style&index=0&id=75b21912&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b21912"]])

export default __exports__